import { module as Module } from "modujs";
import CookieConsent from "vanilla-cookieconsent/dist/cookieconsent.umd.js";

export default class extends Module {
    constructor(m) {
        super(m);

        try {
            this.config = JSON.parse(this.getData('config'));
        } catch (e) {
            console.warn(e.message);
        }

        // Events
        this.events = {
            click: {
                'hide':                   'hideModals',
                'show-preferences-modal': 'showPreferencesModal',
            },
        };
    }

    ///////////////
    // Lifecyle
    ///////////////
    init() {
        if (!this.config.categories || Object.keys(this.config.categories).length === 0) {
            console.warn('[CookieConsent]', 'No categories configured.');
            return;
        }

        CookieConsent.run(this.config);
    }

    destroy() {
        super.destroy();
    }

    ///////////////
    // Callbacks
    ///////////////
    hideModals() {
        CookieConsent.hide();
        CookieConsent.hidePreferences();
    }

    showPreferencesModal() {
        CookieConsent.showPreferences();
    }
}
